<header role="banner" class="theme-leaf">
  <cigna-header
    [isAuthenticated]="isSecure"
    [isResourceLibraryApp]="true"
    [isLogoLinkInternal]="false"
  ></cigna-header>
</header>

<cigna-resources-ui
  [pathname]="pathname"
  [isSecure]="isSecure"
></cigna-resources-ui>
<cigna-video-dialog-loader></cigna-video-dialog-loader>
<cigna-resources-modal></cigna-resources-modal>
